import { downloadFileBy } from './FileLoadUtility'

export function downloadIntlSpecSalaryReport(
  specialistId: any,
  month: number,
  year: number,
) {
  downloadFileBy('/InternationalIncome/GenerateSalaryReport', 'GET', {
    specialistId,
    month,
    year,
  })
}
